import { Input, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionTable from '../../../components/table/ActionTable';
import { deleteUserRequest, getUsers } from '../../../store/actions/users';
import { convertDateStringToFrenchFormat } from '../../../utils/functions';
import { SearchOutlined } from '@ant-design/icons';
import styles from '../index.module.css';
import { useTranslation } from 'react-i18next';

const Users = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const deleteAction = (id) => {
    dispatch(
      deleteUserRequest({
        id,
      })
    );
  };
  const columns = [
    {
      title: t('admin.users.columns.name'),
      dataIndex: ['firstName', 'lastName'],
      key: 'name',
      render: (text, row) => {
        if (row.firstName && row.lastName) {
          return `${row['lastName'].toUpperCase()} ${row['firstName']}`;
        } else if (row.firstName) {
          return row['firstName'];
        } else if (row.lastName) {
          return row['lastName'];
        } else {
          return '-';
        }
      },
      sorter: (a, b) => {
        if (!a.lastName) {
          return +1;
        }
        if (!b.lastName) {
          return -1;
        }
        return a.lastName.localeCompare(b.lastName);
      },
      width: 250,
      ellipsis: true,
    },
    {
      title: t('admin.users.columns.guest'),
      dataIndex: 'guest',
      key: 'email',
      width: 270,
      ellipsis: true,
    },
    {
      title: t('admin.users.columns.sponsor'),
      dataIndex: 'sponsor',
      key: 'sponsor',
      width: 270,
      ellipsis: true,
    },
    {
      title: t('admin.users.columns.company'),
      dataIndex: 'company',
      key: 'company',
      sorter: (a, b) => {
        if (!a.company) {
          return +1;
        }
        if (!b.company) {
          return -1;
        }
        return a.company.localeCompare(b.company);
      },
      width: 120,
      ellipsis: true,
    },
    {
      title: t('admin.users.columns.startAt'),
      dataIndex: 'startAt',
      key: 'startAt',
      width: 150,
      sorter: (a, b) => {
        if (new Date(a.startAt) < new Date(b.startAt)) return -1;
        if (new Date(a.startAt) > new Date(b.startAt)) return 1;
        return 0;
      },

      render: (startAt) => {
        if (startAt) {
          return convertDateStringToFrenchFormat(startAt);
        }
        return '-';
      },
    },
    {
      title: t('admin.users.columns.endAt'),
      dataIndex: 'endAt',
      key: 'endAt',
      width: 150,
      sorter: (a, b) => {
        if (new Date(a.endAt) < new Date(b.endAt)) return -1;
        if (new Date(a.endAt) > new Date(b.endAt)) return 1;
        return 0;
      },
      render: (endAt) => {
        if (endAt) {
          return convertDateStringToFrenchFormat(endAt);
        }
        return '-';
      },
    },
    {
      title: t('admin.users.columns.actions'),
      key: 'actions',
      width: 100,
      fixed: 'right',
      render: (text, record) => (
        <ActionTable
          record={record}
          link={'/admin/users/'}
          deleteAction={deleteAction}
        />
      ),
    },
  ];

  //States
  const [dataSource, setDataSource] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchUser, setSearchUser] = useState('');

  const { users, loading } = useSelector((state) => state.users);

  useEffect(() => {
    if (!users.length) {
      dispatch(getUsers());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = (e) => {
    setSearchUser(e);
  };

  useEffect(() => {
    const keys = [
      'lastName',
      'firstName',
      'email',
      'company',
      'sponsor',
      'startAt',
      'endAt',
      'guest',
    ];
    const delayDebounceSearch = setTimeout(() => {
      if (searchUser) {
        const trimedSearchUser = searchUser.toLowerCase();
        setDataSource(
          users.filter((user, index) => {
            let isFound = false;

            keys.forEach((key) => {
              if (user[key]) {
                if (user[key].toLowerCase().includes(trimedSearchUser)) {
                  isFound = true;
                } else if (
                  convertDateStringToFrenchFormat(user[key])
                    .toString()
                    .toLowerCase()
                    .includes(trimedSearchUser)
                ) {
                  isFound = true;
                }
              }
            });
            return isFound;
          })
        );
      } else {
        setDataSource(users);
      }
    }, 500);
    return () => clearTimeout(delayDebounceSearch);
  }, [searchUser, users]);

  useEffect(() => {
    setDataSource(users);
    setIsLoading(loading);
  }, [users, loading]);

  return (
    <div className={`${styles['admin-content']} ${styles['network-content']}`}>
      <div className={styles.table__header}>
        <h2 className={styles.table__title}>{t('admin.users.title')}</h2>

        <div className={styles.table__search}>
          <Input
            placeholder={t('admin.users.placeholder.search')}
            onChange={(e) => {
              handleSearch(e.target.value);
            }}
            value={searchUser}
            prefix={<SearchOutlined />}
            allowClear
          />
        </div>
      </div>

      <Table
        className={styles.table}
        columns={columns}
        dataSource={dataSource}
        loading={isLoading}
        scroll={{ x: 1320 }}
        rowKey='id'
      />
    </div>
  );
};

export default Users;
